import { Common, color, device, Header } from '@stockbit/ui';
import styled from 'styled-components';

const { Flex, PopoverContent } = Common;
const { PopoverContainer } = Header;

const CustomPopoverContainer = styled(PopoverContainer)`
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  max-height: unset;
  border: none;
  background-color: white;
`;

const PopoverContentMobile = styled(PopoverContent)`
  max-height: 100%;
`;

const NewTag = styled.span`
  width: 34px;
  height: 16px;
  padding: 3px 4px 3px 4px;
  border-radius: 4px;
  gap: 10px;
  border: 1px solid rgba(0, 171, 107, 1);
  color: rgba(0, 171, 107, 1);
  font-size: 11px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const MenuList = styled(Flex)`
  align-items: center;
  padding: 0 10px;
  cursor: pointer;

  & > p {
    padding-left: 8px;
  }

  @media ${device.tablet} {
    & > p {
      padding-left: 0;
    }
  }

  :hover {
    background: ${color.downgray};
    p,
    p::before {
      color: ${color.primary};
    }
  }
`;

const MenuListContainer = styled.div`
  border-bottom: 1px solid ${color.lowgray};
  padding: 8px 0;
  :last-child {
    border-bottom: none;
    padding-bottom: 4px;
    padding-top: 2px;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  height: 30px;
  width: 30px;
  align-items: center;
  justify-content: center;
  img {
    height: 16px;
    width: 16px;
  }
`;

export {
  CustomPopoverContainer,
  PopoverContentMobile,
  MenuList,
  NewTag,
  MenuListContainer,
  ImageWrapper,
};
